export const profile = {
  name: 'Газизуллин Ринат Ришатович',
  location: 'Санкт-Петербург',
  education: 'Университет ИТМО, 3 курс',
  specialization: 'Системное и прикладное программное обеспечение',
  english: 'B1–B2',
};

export const skills = [
  { label: 'language', items: ['Kotlin', 'Java', 'C', 'Python', 'Assembly'] },
  { label: 'mobile', items: ['Compose Multiplatform', 'Voyager', 'Koin', 'StateFlow', 'Coroutines'] },
  { label: 'build', items: ['Gradle', 'CMake', 'Maven'] },
  { label: 'version', items: ['Git', 'Mercurial'] },
  { label: 'data', items: ['PostgreSQL', 'SQLite', 'Room'] },
  { label: 'web', items: ['React + Redux', 'Angular', 'WildFly', 'JSP'] },
  { label: 'tools', items: ['GitHub Actions', 'Typst'] },
];

export const categories = [
  { id: 'mobile', title: 'Мобильная разработка' },
  { id: 'systems', title: 'Системное программирование' },
  { id: 'other', title: 'Остальные проекты' },
];
